import classNames from 'classnames';
import { Children, ReactNode } from 'react';
import styles from './ResponsiveGrid.module.scss';

type ResponsiveGridProps = {
  children: ReactNode;
  className?: string;
  equalColumns?: boolean;
  oneLessChildOnDesktop?: boolean;
  tabletLastChildFull?: boolean;
};

const ResponsiveGrid = ({ children, className, equalColumns, oneLessChildOnDesktop, tabletLastChildFull }: ResponsiveGridProps) => {
  const filteredChildren = Children.toArray(children).filter(Boolean);
  const childCount = filteredChildren.length;

  const gridClass = () => {
    if (childCount === 1) {
      return styles.gridOne;
    } else if (childCount === 2) {
      return styles.gridTwo;
    } else if (childCount === 3) {
      return styles.gridThree;
    } else {
      return styles.gridFour;
    }
  };

  return (
    <div
      className={classNames(
        gridClass(),
        { [styles.oneLessChildOnDesktop]: oneLessChildOnDesktop, [styles.equalColumns]: equalColumns, [styles.lastChildFull]: tabletLastChildFull },
        className
      )}
    >
      {children}
    </div>
  );
};

export default ResponsiveGrid;
